// Library methods
import { jwtDecode, JwtPayload } from "jwt-decode";

const getUserFromToken = (token: string) => {
  const decoded = jwtDecode(token);
  const decodedKey = "https://callback.retinalogik/roles" as keyof JwtPayload;
  const emailKey = "https://callback.retinalogik/email" as keyof JwtPayload;
  const roles = decoded[decodedKey] as string[];
  const userEmail = decoded[emailKey] as string;
  const hasRole = roles?.length > 0;
  const isAdmin = hasRole && roles?.includes("Admin");

  return {
    roles,
    hasRole,
    isAdmin,
    userEmail,
  };
};

export default getUserFromToken;
